<div class="alarm-list-item-info">

    <span *ngIf="!driver" class="alarm-list-item-info__label" [title]="defaultDriverName">{{ defaultDriverName }}</span>
    <span *ngIf="driver" class="alarm-list-item-info__label alarm-list-item-info__link" [routerLink]="['/panel' , 'driver']"
        [queryParams]="{mode:'details', id: event?.DI}" [title]="(driver.FN + ' ' + driver.LN)">
        {{ driver.FN }} {{ driver.LN }}
    </span>

    <span class="alarm-list-item-info__dot">&#8226;</span>

    <span *ngIf="!vehicle" class="alarm-list-item-info__label" [title]="defaultVehicleName">{{ defaultVehicleName }}</span>
    <span *ngIf="vehicle" class="alarm-list-item-info__label alarm-list-item-info__link" [routerLink]="['/panel' , 'vehicle']"
        [queryParams]="{mode:'details', id: event?.VI}" [title]="vehicle.Nm">
        {{ vehicle.Nm }}
    </span>

</div>
